export default __webpack_public_path__ + "static/media/keto_breakfast_time@3x.786b9475.jpg";